import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SmartFormStates } from './SmartForm';
import ErrorWrapper from '@component/ErrorWrapper';
import { syncValidatorResults } from "@component/smartForm/validatorUtils"
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { formatDateTimeWithoutSeconds } from '@utils/timeUtil';

dayjs.extend(utc);
dayjs.extend(timezone);

const SmartDateTimeInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  renderView,
  editable = true,
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  startIcon,
  ampm,
  ...props
}) => {
  const [showError, setShowError] = useState(false);
  const [validatorResult, setValidatorResult] = useState('');

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);

  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label)
      setValidatorResult(validatorResult)
    }
  }, [value, validator, validatorResults, setValidatorResults, label])

  const handleChange = (newValue) => {
    let isoString = null;
    if (newValue) {
      isoString = newValue.toISOString();
    }
    onChange(field, isoString);
  };

  const parsedDateTime = value ? dayjs.utc(value).local() : null;

  return (
    <Box sx={sx}>
      {!isEdit || !editable ? (
        renderView ? (
          renderView(value)
        ) : (
          <>
            {label && <Typography
              variant="caption"
              component="div"
              sx={{
                color: 'text.secondary',
                fontSize: '0.75rem',
                lineHeight: 1.66,
                mb: 0.5
              }}
            >
              {label}
            </Typography>
            }
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {startIcon && (
                <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                  {startIcon}
                </Box>
              )}
              <Typography variant="body1">
                {value ? formatDateTimeWithoutSeconds(value) : '-'}
              </Typography>
            </Box>
          </>
        )
      ) : (
        <ErrorWrapper message={validatorResult} showMessage={showError}>
          <DateTimePicker
            label={label}
            value={parsedDateTime}
            onChange={handleChange}
            format="DD.MM.YYYY HH:mm"
            ampm={ampm}
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                sx: {
                  '& .MuiInputBase-root': {
                    mt: 0.75,
                  },
                },
              },
            }}
            {...props}
          />
        </ErrorWrapper>
      )}
    </Box>
  );
};

export default SmartDateTimeInput;